module.exports = __webpack_public_path__ + "tourbi.gif?5cdb02282b0e8794bb15555255e204f0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tourbi.gif
// module id = 27
// module chunks = 0